import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
// import Highcharts from 'highcharts';
// import HighchartsReact from 'highcharts-react-official';
// import Highcharts3D from 'highcharts/highcharts-3d';
// import { Tabs, Tab } from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { useSelector } from 'react-redux';

// // Only call if necessary (if 3D isn't already enabled in your version)
// // Highcharts3D(Highcharts);
const COLORS = [
    '#3b82f6', // Free (Gray)
    '#f59e0b', // Basic (Sky Blue)
    '#10b981', // Professional (Indigo)
    '#ef4444'  // Enterprise (Emerald)
];

const DonutChart = () => {
    const [subscriberByPlan, setSubscriberByPlan] = useState([]);
    const { subscriber_by_plan } = useSelector(state => state.data);

    useEffect(() => {
        // Safely verify the internal payload structure from the API
        if (subscriber_by_plan.length > 0) {
            const formattedData = subscriber_by_plan.map((item, index) => ({
                name: item.plan,
                // Fix 1: Map the API "count" to "value" so Recharts can read it
                value: item.count || 0,
                percentage: item.percentage || 0,
                // Fix 2: Inject the UI styling colors into the data object dynamically
                color: COLORS[index % COLORS.length]
            }));
            setSubscriberByPlan(formattedData);
        }
    }, [subscriber_by_plan]);

    // Prevent rendering if data hasn't loaded yet
    if (subscriberByPlan.length === 0) {
        return <div className="text-slate-400 text-sm">Loading chart data...</div>;
    }

    return (
        <div style={{ width: '100%', height: 250 }}>
            {/* Fix 3: Wrap inside an active ResponsiveContainer for responsive scaling */}
            <ResponsiveContainer>
                <PieChart>
                    <Pie
                        data={subscriberByPlan}
                        cx="50%"
                        cy="50%"
                        innerRadius={75}
                        outerRadius={100}
                        paddingAngle={2}
                        dataKey="value" // Target mapped object variable
                    >
                        {subscriberByPlan.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>

                    <Tooltip
                        formatter={(value, name, props) => [
                            `${value} (${props.payload.percentage}%)`,
                            name
                        ]}
                        contentStyle={{
                            background: '#0f172a',
                            borderRadius: '8px',
                            border: 'none',
                            color: '#fff',
                            fontSize: '13px',
                        }}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    );
}

export default DonutChart;

// const DonutChart = () => {
//     const { countryGraph } = useSelector(state => state.data);
//     const { industryGraph } = useSelector(state => state.data);
//     const [activeKey, setActiveKey] = useState('countries');

//     const getChartData = () => {
//         if (activeKey === 'countries') {
//             const data = countryGraph.map(({ country, percentage }) => [country, percentage]);
//             // console.log(data, "data")
//             return data;
//         } else {
//             const data = industryGraph.map(({ industry, percentage }) => [industry, percentage]);
//             // console.log(data, "data")
//             return data;
//         }
//     };

//     const chartOptions = {
//         chart: {
//             type: 'pie',
//             options3d: {
//                 enabled: true,
//                 alpha: 45,
//                 beta: 0,
//             },
//             backgroundColor: '#fff',
//         },
//         title: {
//             text: 'Count and Distribution',
//             align: 'center',
//         },
//         credits: { enabled: false }, // 🔹 remove "highcharts.com"
//         plotOptions: {
//             pie: {
//                 innerSize: 100,
//                 depth: 45,
//                 dataLabels: {
//                     enabled: true,
//                     format: '{point.name}: {point.percentage:.1f} %',
//                 },
//             },
//         },
//         series: [
//             {
//                 name: activeKey === 'countries' ? 'Countries' : 'Industries',
//                 data: getChartData(),
//             },
//         ],
//     };

//     return (
//         <div className='donut-chart-div'>
//             <Tabs
//                 id="donut-chart-tabs"
//                 activeKey={activeKey}
//                 onSelect={(k) => setActiveKey(k)}
//                 className="mb-3"
//             >
//                 <Tab eventKey="countries" title="Countries">
//                     <HighchartsReact highcharts={Highcharts} options={chartOptions} />
//                 </Tab>
//                 <Tab eventKey="industries" title="Industries">
//                     <HighchartsReact highcharts={Highcharts} options={chartOptions} />
//                 </Tab>
//             </Tabs>
//         </div>
//     );
// };

// export default DonutChart;
